
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...catId]",
      function () {
        return require("private-next-pages/[...catId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...catId]"])
      });
    }
  